import TH_Form from '_tradeholding/js/Classes/Form';
import NotificationBox from '_loaders/NotificationBox';
import '_premierworld/scss/form/form.scss';

class PW_Form extends TH_Form {
    /** Default form success response function
     * 
     * @param object data 		(the response data received)
     * 
     */
    defaultSuccessResponse(event, data) {
        let message;

        if (typeof data.message != 'undefined') message = data.message;
        else message = "No message received";

        NotificationBox.createNotification('success', message, 'check-circle');
    
        return true;
    }
}

export default PW_Form;